import { MessageSquare } from 'lucide-react'

/** Attach this entity as a composer chip. Not "Open in chat" (start a thread). */
export const ADD_TO_CURRENT_CHAT_LABEL = 'Add to current chat'

export const AddToCurrentChatIcon = MessageSquare
